module.exports = window["MaterialUI"].DialogContentText;